import {isRtl} from 'scratch-l10n';
import editorMessages from 'scratch-l10n/locales/editor-msgs';

const UPDATE_LOCALES = 'scratch-gui/locales/UPDATE_LOCALES';
const SELECT_LOCALE = 'scratch-gui/locales/SELECT_LOCALE';

const customPixelblockMessages = {
    en: {
        'gui.pixelblock.runPython': 'Run Python',
        'gui.pixelblock.runPythonTitle': 'Run Python code in browser',
        'gui.pixelblock.exportPy': 'Export .py',
        'gui.pixelblock.exportPyTitle': 'Export project to .py file',
        'gui.pixelblock.importPy': 'Import .py',
        'gui.pixelblock.importPyTitle': 'Import a .py file into blocks',
        'gui.pixelblock.showPythonCode': 'Python Code',
        'gui.pixelblock.hidePythonCode': 'Hide Code',
        'gui.pixelblock.showPythonCodeTitle': 'Show Python Code',
        'gui.pixelblock.hidePythonCodeTitle': 'Hide Python Code',
        'gui.pixelblock.pythonCode': 'Python Code',
        'gui.pixelblock.toBlocks': 'To Blocks',
        'gui.pixelblock.toBlocksTitle': 'Parse code into blocks',
        'gui.pixelblock.copy': 'Copy',
        'gui.pixelblock.copied': 'Copied',
        'gui.pixelblock.export': 'Export',
        'gui.pixelblock.close': 'Close',
        'gui.pixelblock.codePlaceholder': '# Python code will appear here as you add blocks...',
        'gui.pixelblock.realtimeCode': 'Real-time Python code generation',
        'gui.pixelblock.refresh': 'Refresh',
        'gui.pixelblock.console': 'Console',
        'gui.pixelblock.clear': 'Clear',
        'gui.pixelblock.clearTitle': 'Clear console',
        'gui.pixelblock.running': 'Running...',
        'gui.pixelblock.finished': 'Finished',
        'gui.pixelblock.error': 'Error',
        'gui.pixelblock.ready': 'Ready',
        'gui.pixelblock.readyHelp': 'Ready. Click "▶ Run Python" to execute your code.',
        'gui.pixelblock.runningStart': '>>> Running Python program...\n',
        'gui.pixelblock.completedSuccess': '>>> Program completed successfully.\n',
        'gui.pixelblock.convertSuccess': 'Python code converted into blocks successfully!',
        'gui.pixelblock.convertError': 'Error converting to blocks: ',
        'gui.pixelblock.decreaseFontSize': 'Decrease text size',
        'gui.pixelblock.increaseFontSize': 'Increase text size',
                'gui.pixelblock.resizeConsole': 'Drag to resize console',
        'gui.gui.defaultProjectTitle': 'PixelBlocks Project',
        'gui.alerts.lostPeripheralConnection': 'PixelBlocks lost connection to {extensionName}.',
        'gui.unsupportedBrowser.notRecommended': 'We are very sorry, but it looks like you are using a browser version that PixelBlocks does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.',
        'gui.unsupportedBrowser.description': 'We are very sorry, but PixelBlocks does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.',
        'gui.crashMessage.description': 'We are so sorry, but it looks like PixelBlocks has crashed. Please refresh your page to try again.',
        'gui.menuBar.joinScratch': 'Join PixelBlocks',
        'gui.telemetryOptIn.label': 'Report statistics to improve PixelBlocks',
        'gui.telemetryOptIn.body1': 'The PixelBlocks Team is always looking to better understand how PixelBlocks is used around the world.',
        'gui.telemetryOptIn.optInText': 'Share my usage data with the PixelBlocks Team',
        'gui.telemetryOptIn.optOutText': 'Do not share my usage data with the PixelBlocks Team',
        "gui.webglModal.description": "Unfortunately it looks like your browser or computer <a>{webGlLink}</a>. This technology is needed for PixelBlocks to run.",
    },
    fr: {
        'gui.pixelblock.runPython': 'Exécuter Python',
        'gui.pixelblock.runPythonTitle': 'Exécuter le code Python dans le navigateur',
        'gui.pixelblock.exportPy': 'Exporter .py',
        'gui.pixelblock.exportPyTitle': 'Exporter le projet en fichier .py',
        'gui.pixelblock.importPy': 'Importer .py',
        'gui.pixelblock.importPyTitle': 'Importer un fichier .py dans les blocs',
        'gui.pixelblock.showPythonCode': 'Code Python',
        'gui.pixelblock.hidePythonCode': 'Masquer le code',
        'gui.pixelblock.showPythonCodeTitle': 'Afficher le code Python',
        'gui.pixelblock.hidePythonCodeTitle': 'Masquer le code Python',
        'gui.pixelblock.pythonCode': 'Code Python',
        'gui.pixelblock.toBlocks': 'Vers les blocs',
        'gui.pixelblock.toBlocksTitle': 'Convertir le code en blocs',
        'gui.pixelblock.copy': 'Copier',
        'gui.pixelblock.copied': 'Copié',
        'gui.pixelblock.export': 'Exporter',
        'gui.pixelblock.close': 'Fermer',
        'gui.pixelblock.codePlaceholder': '# Le code Python s\'affichera ici à mesure que vous ajoutez des blocs...',
        'gui.pixelblock.realtimeCode': 'Génération du code Python en temps réel',
        'gui.pixelblock.refresh': 'Actualiser',
        'gui.pixelblock.console': 'Console',
        'gui.pixelblock.clear': 'Effacer',
        'gui.pixelblock.clearTitle': 'Effacer la console',
        'gui.pixelblock.running': 'Exécution...',
        'gui.pixelblock.finished': 'Terminé',
        'gui.pixelblock.error': 'Erreur',
        'gui.pixelblock.ready': 'Prêt',
        'gui.pixelblock.readyHelp': 'Prêt. Cliquez sur « ▶ Exécuter Python » pour exécuter votre code.',
        'gui.pixelblock.runningStart': '>>> Exécution du programme Python...\n',
        'gui.pixelblock.completedSuccess': '>>> Programme terminé avec succès.\n',
        'gui.pixelblock.convertSuccess': 'Code Python converti en blocs avec succès !',
        'gui.pixelblock.convertError': 'Erreur lors de la conversion en blocs : ',
        'gui.pixelblock.decreaseFontSize': 'Diminuer la taille du texte',
        'gui.pixelblock.increaseFontSize': 'Augmenter la taille du texte',
                'gui.pixelblock.resizeConsole': 'Glisser pour redimensionner la console',
        "gui.gui.defaultProjectTitle": "Projet PixelBlocks",
        "gui.alerts.lostPeripheralConnection": "Connexion entre PixelBlocks et {extensionName} perdue.",
        "gui.unsupportedBrowser.notRecommended": "Nous sommes désolés, mais on dirait que la version de votre navigateur n'est pas supportée par PixelBlocks. Nous vous recommandons une mise à jour vers la dernière version d'un navigateur supporté comme Google Chrome, Mozilla Firefox, Microsoft Edge ou Apple Safari.",
        "gui.unsupportedBrowser.description": "Nous sommes désolés mais ce navigateur n'est pas supporté par PixelBlocks. Nous vous recommandons d'utiliser la dernière version d'un navigateur comme Google Chrome, Mozilla Firefox, Microsoft Edge ou Apple Safari.",
        "gui.crashMessage.description": "Nous sommes désolés, mais on dirait que PixelBlocks a planté. Merci de rafraîchir la page pour essayer à nouveau.",
        "gui.menuBar.joinScratch": "Rejoindre PixelBlocks",
        "gui.telemetryOptIn.label": "Envoyer des statistiques pour améliorer PixelBlocks",
        "gui.telemetryOptIn.body1": "L'équipe PixelBlocks cherche à toujours mieux comprendre comment PixelBlocks est utilisé dans le monde.",
        "gui.telemetryOptIn.optInText": "Partager mes données d'utilisation avec l'équipe PixelBlocks",
        "gui.telemetryOptIn.optOutText": "Ne pas partager mes données d'utilisation avec l'équipe PixelBlocks",
        "gui.webglModal.description": "Malheureusement, il semble que votre navigateur ou votre ordinateur <a>{webGlLink}</a>. Cette technologie est nécessaire pour faire fonctionner PixelBlocks."
    }
};

if (editorMessages.en) {
    Object.assign(editorMessages.en, customPixelblockMessages.en);
}
if (editorMessages.fr) {
    Object.assign(editorMessages.fr, customPixelblockMessages.fr);
}
if (!editorMessages.python) {
    editorMessages.python = Object.assign({}, editorMessages.en, customPixelblockMessages.en);
}

const initialState = {
    isRtl: false,
    locale: 'en',
    messagesByLocale: editorMessages,
    messages: editorMessages.en
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SELECT_LOCALE:
        if (typeof window !== 'undefined') {
            window.pixelblockCurrentLocale = action.locale;
        }
        return Object.assign({}, state, {
            isRtl: isRtl(action.locale),
            locale: action.locale,
            messagesByLocale: state.messagesByLocale,
            messages: state.messagesByLocale[action.locale]
        });
    case UPDATE_LOCALES:
        return Object.assign({}, state, {
            isRtl: state.isRtl,
            locale: state.locale,
            messagesByLocale: action.messagesByLocale,
            messages: action.messagesByLocale[state.locale]
        });
    default:
        return state;
    }
};

const selectLocale = function (locale) {
    return {
        type: SELECT_LOCALE,
        locale: locale
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages
    };
};
const initLocale = function (currentState, locale) {
    if (Object.prototype.hasOwnProperty.call(currentState.messagesByLocale, locale)) {
        return Object.assign(
            {},
            currentState,
            {
                isRtl: isRtl(locale),
                locale: locale,
                messagesByLocale: currentState.messagesByLocale,
                messages: currentState.messagesByLocale[locale]
            }
        );
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales
};
